import { render, staticRenderFns } from "./EventJoinButton.vue?vue&type=template&id=f604169c"
import script from "./EventJoinButton.vue?vue&type=script&lang=js"
export * from "./EventJoinButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports